
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"24","cy":"24","r":"16.8","fill":"currentColor"}}),_c('path',{attrs:{"d":"M22.442 34h-1.11l1.11-7.778h-3.889c-.977 0-.366-.833-.344-.866 1.433-2.534 3.589-6.312 6.467-11.356h1.11l-1.11 7.778h3.9c.444 0 .689.21.444.733A8706.891 8706.891 0 0022.442 34z","fill":"#fff"}})])
          )
        }
      }
    